import { lazyWithRetry as lazy } from '../../helpers/lazyWithRetry';

export const RouteComponents: {
  [key: string]: React.LazyExoticComponent<React.ComponentType>;
} = {
  AccessLogs: lazy(() => import('../../pages/access-logs/AccessLogs')),
  Comparison: lazy(
    () => import('../../pages/infra-service/fjv-specific/Comparison'),
  ),
  ConcernReport: lazy(() => import('../../pages/concern-report/ConcernReport')),
  ConcernStructure: lazy(
    () => import('../../pages/concern-structure/ConcernStructure'),
  ),
  ConfirmAccount: lazy(
    () => import('../../pages/confirm-account/ConfirmAccount'),
  ),
  Contracts: lazy(() => import('../../pages/contracts/Contracts')),
  Cooling: lazy(() => import('../../pages/infra-service/fjv-specific/Cooling')),
  Debug: lazy(() => import('../../pages/debug/Debug')),
  DistanceHeatingContract: lazy(
    () =>
      import('../../pages/distance-heating-contract/DistanceHeatingContract'),
  ),
  FJVEnergy: lazy(
    () => import('../../pages/infra-service/fjv-specific/FJVEnergy'),
  ),
  FlowCharge: lazy(
    () => import('../../pages/infra-service/fjv-specific/FlowCharge'),
  ),
  GridFeeComparison: lazy(
    () => import('../../pages/grid-fee-comparison/GridFeeComparison'),
  ),
  InfraService: lazy(() => import('../../pages/infra-service/InfraService')),
  InvoiceReference: lazy(
    () => import('../../pages/invoice-reference/InvoiceReference'),
  ),
  Invoices: lazy(() => import('../../pages/invoices/Invoices')),
  Landing: lazy(() => import('../../pages/landing/Landing')),
  ManageHanPort: lazy(() => import('../../pages/manage-han-port')),
  MeterReadings: lazy(() => import('../../pages/meter-readings/MeterReadings')),
  NonCustomer: lazy(() => import('../../pages/non-customer/NonCustomer')),
  PeakPowerTriple: lazy(
    () => import('../../pages/infra-service/el-specific/PeakPowerTriple'),
  ),
  PeakPower: lazy(() => import('../../pages/peak-power/PeakPower')),
  PowerHub: lazy(() => import('../../pages/power-hub/PowerHub')),
  PowersOfAttorney: lazy(
    () => import('../../pages/powers-of-attorney/PowersOfAttorney'),
  ),
  ElectricityPriceCalculator: lazy(
    () => import('../../pages/electricity-price-calculator/PriceCalculator'),
  ),
  FjvPriceCalculator: lazy(
    () => import('../../pages/fjv-price-calculator/PriceCalculator'),
  ),
  Reports: lazy(() => import('../../pages/reports/Reports')),
  Spotpriser: lazy(() => import('../../pages/spotpriser/Spotpriser')),
  UtjamnadBetalning: lazy(
    () => import('../../pages/utjamnad-betalning/UtjamnadBetalning'),
  ),
  Flow: lazy(() => import('../../pages/flow/Flow')),
  Profile: lazy(() => import('../../pages/profile/Profile')),
  HeatExchangeControl: lazy(
    () => import('../../pages/heat-exchange-control/HeatExchangeControl'),
  ),
};
